import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import PropTypes from "prop-types";

import { useDownloadExcel } from 'react-export-table-to-excel';
import { useRef } from "react";
import { TablePagination } from "@mui/material";
import { useHistorial } from "./useHistorial";


function HistorialTable({rows}) {

  const {loaded} = useHistorial()

  const [search, setSearch] = React.useState('')
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => { 
    setPage(0); 
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const tableRef = useRef(null);

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: 'Historial Fresenius',
    sheet: 'historial',
  });

  if(!loaded){
    return(
      <div>
        <p>Cargando...</p>
      </div>
    )
  }

  const onSearchChange = ({target}) => {
    setPage(0);
    setSearch(target.value.toLowerCase())
  }

  const filteredRows = search.length === 0
    ? rows
    : rows.filter(row => row.data.toLowerCase().includes(search));

  const sortedRows = [...filteredRows].sort((a, b) => b.fecha - a.fecha);

  const paginatedRows = rowsPerPage === -1
    ? sortedRows
    : sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <div>
      <input 
        type="text" 
        placeholder="Buscar"
        value={search}
        onChange={onSearchChange}
      />

      <TablePagination
        rowsPerPageOptions={[10, 25, 50, { value: -1, label: 'All' }]}
        component="div"
        count={filteredRows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <button style={{
        color: 'white',
        background: '#0063BE',
      }} onClick={onDownload}> Export excel 
      </button>

      <TableContainer component={Paper}>                 
        <Table ref={tableRef} sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>   
            <TableRow>
              <TableCell>Nombre</TableCell>
              <TableCell align="right">Fecha</TableCell>
              <TableCell align="right">Producto (F)</TableCell>
              <TableCell align="right">Precio (F)</TableCell>
              <TableCell align="right">Calorías (F)</TableCell>
              <TableCell align="right">Producto (otro)</TableCell>
              <TableCell align="right">Precio (otro)</TableCell>
              <TableCell align="right">Calorías (otro)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.map((row) => {
              const row2 = JSON.parse(row.data);
              const date = new Date(row.fecha * 1);
              const fecha = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;

              return (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">{row2.user}</TableCell>
                  <TableCell align="right">{fecha}</TableCell>
                  <TableCell align="right">{row2.inputF1}</TableCell>
                  <TableCell align="right">{row2.inputF2}</TableCell>
                  <TableCell align="right">{row2.inputF3}</TableCell>
                  <TableCell align="right">{row2.inputO1}</TableCell>
                  <TableCell align="right">{row2.inputO2}</TableCell>
                  <TableCell align="right">{row2.inputO3}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

HistorialTable.propTypes = {
  rows: PropTypes.array.isRequired,
};

export default HistorialTable;
